<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Unlinked Entry Passes
        <span *ngIf="unlinkedEntryPassCustomers">({{ unlinkedEntryPassCustomers.length }})</span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Purchase Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Entry Pass Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingUnlinkedEntryPassCustomers && unlinkedEntryPassesPresent()">
      <tr *ngFor="let unlinkedEntryPassCustomer of unlinkedEntryPassCustomers">
        <td>
          {{ dateStringFromISO8601(unlinkedEntryPassCustomer.purchased_at) }}
        </td>
        <td>{{ unlinkedEntryPassCustomer.first_name }} {{ unlinkedEntryPassCustomer.last_name }}</td>
        <td>{{ unlinkedEntryPassCustomer.entry_pass_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewUnlinkedEntryPassCustomerModal(unlinkedEntryPassCustomer);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingUnlinkedEntryPassCustomers || !unlinkedEntryPassesPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingUnlinkedEntryPassCustomers">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingUnlinkedEntryPassCustomers && !unlinkedEntryPassesPresent()">
          No outstanding unlinked entry passes.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
